// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__2_-nD","small":"avatar_small__302Vp","medium":"avatar_medium__2brmF","large":"avatar_large__3090_"};